/* eslint-disable react/display-name */
import getMappedProduct from './getMappedProduct';

export default function (products = null, appProductConfig, pageType, messages, useIdentifier, config, userState = { user: {} }) {
    if (!products) return null;
    const {
        pdpUrlTemplate,
        locale,
        badgeBlocklist = [],
        availableImageSizes = [],
        imageQuality,
        saleBadges,
        imagesphereAspectRatio,
        plpImageSrcSet,
    } = appProductConfig;
    const { user } = userState;

    return products.map((product) => {
        const consideredBadge = product?.attributes?.find((attribute) => {
            return config?.head?.sustainabilityAttributes.includes(attribute.identifier) || attribute.identifier === 'CONSIDERED';
        });
        return product
            ? getMappedProduct({
                  id: product.productId,
                  product: product,
                  badgeBlocklist,
                  locale,
                  availableImageSizes,
                  pdpUrlTemplate,
                  imageQuality,
                  pageType,
                  messages,
                  saleBadges,
                  useIdentifier,
                  imagesphereAspectRatio,
                  consideredBadge: consideredBadge?.label ? consideredBadge?.label : null,
                  plpImageSrcSet,
                  user,
              })
            : null;
    });
}
